export enum PartnerResellers {
    burrelles = 'burrelles',
    lexisNexis = 'lexisNexis',
    kantar = 'kantar',
    unicepta = 'unicepta',
    newsdirect = 'newsdirect',
    paMedia = 'paMedia',
    refmedia = 'refmedia',
}
